(($)=>{

    $('[data-collection-header-slider]').each(function initSlider(){
        const $el = $(this);
        const $slick = $('[data-slides-wrapper]', $el);
        const $dots = $('[data-dots-wrapper]', $el);


        $slick.slick({
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            fade: true,
            appendDots: $dots
        });

    })

})(jQuery)